export function joinPath(parts: string[], separator: string = '/'): string {
    return parts
        .filter(p => !!p)
        .map(p => p.replace(new RegExp(`${separator}+$`), ''))
        .join(separator);
}
